import React from 'react'
import { correctSlugPrefix, isExternalURL } from '../../../src/utils/link.utils'
import MODULE_MAPPING from '../../constants/contentIDs'

//* components
import Image from '../../../src/components/global/image'

export const entryHyperlink = (node: any, children: any) => {
  const { sys, fields } = node.data?.target
  const id = sys?.contentType?.sys?.id
  if (!id) return null

  const linkText = (node.content && node.content[0]?.value) || ''
  switch (id) {
    case MODULE_MAPPING.WRAPPER_ASSET:
      const altText = fields?.image?.altText || ''
      const imgURL = fields?.image?.file?.url ? `https:${fields.image.file.url}` : ''

      const imageData = {
        imageFile: {
          file: {
            title: altText,
            url: imgURL,
          },
        },
      }

      return imgURL && linkText ? (
        <a href={linkText}>
          <Image data={imageData} outerPage={''} />
        </a>
      ) : null

    case MODULE_MAPPING.HOMEPAGE:
      return <a href="/">{linkText}</a>

    default:
      const slug = fields?.slug || ''
      return slug && linkText ? <a href={correctSlugPrefix(slug)}>{children}</a> : null
  }
}

export const hyperlink = (node: any) => {
  if (node.data?.uri) {
    const nodeContent = node.content || null
    let linkText = ``

    if (nodeContent) {
      for (let content of nodeContent) {
        let value = content.value

        if (content.marks) {
          for (let mark of content.marks) {
            if (mark.type === 'bold') {
              value = `<strong>${value}</strong>`
            } else if (mark.type === 'italic') {
              value = `<em>${value}</em>`
            }
          }
        }

        if (value) {
          linkText += value
        }
      }
    }

    if (isExternalURL(node.data.uri)) {
      return (
        <a
          href={node.data.uri}
          target="_blank"
          rel="noopener"
          dangerouslySetInnerHTML={{ __html: linkText }}></a>
      )
    } else {
      return <a href={node.data.uri} dangerouslySetInnerHTML={{ __html: linkText }}></a>
    }
  }
}
